// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"73f9ac2d","599":"6f532a50","858":"088e83cc"}[chunkId] + ".chunk.css";
};